// load sass
import '../sass/common.scss';
// modernizr // webp
// import {modernizer}  from "./common/modernizr.js";
// modernizer();
// // load imageSwitch
// import {imageSwitch} from "./common/sub_imageswtch.js";
// imageSwitch();

// WPA バージョン管理用
const appVersion = '1.0.0';

window.addEventListener('load', () => {

  if (document.getElementsByClassName('js_smart_menu')[0]) {
    document.getElementsByClassName('js_smart_menu')[0].onclick = () => {
      if (document.getElementsByClassName('js_smart_menu')[0].classList.contains('active')) {
        document.getElementsByClassName('js_smart_menu')[0].classList.remove('active')
        document.getElementById('smart-menu').classList.remove('active')
      } else {
        document.getElementsByClassName('js_smart_menu')[0].classList.add('active')
        document.getElementById('smart-menu').classList.add('active')
      }
    }
  }


  // loading wait
  if(document.getElementsByClassName('loading_wait')[0]) {
    setTimeout(() => {
      document.getElementsByClassName('loading_wait')[0].classList.add('fade')
      setTimeout(() => {
        document.getElementsByClassName('loading_wait')[0].classList.add('cmpl')
      }, 1000);
    }, 2000);
  }

  document.getElementsByClassName('window_mode')[0].onclick = () => {
    if (document.getElementsByTagName('body')[0].classList.contains('dark_mode')) {
      document.getElementsByTagName('body')[0].classList.remove('dark_mode')
      document.getElementsByClassName('window_mode')[0].classList.remove('dark_mode')
      document.getElementsByClassName('window_mode')[0].classList.add('daylight')
    } else {
      document.getElementsByTagName('body')[0].classList.add('dark_mode')
      document.getElementsByClassName('window_mode')[0].classList.remove('daylight')
      document.getElementsByClassName('window_mode')[0].classList.add('dark_mode')
    }
  }

  function twoDigit(num) {
    let ret;
    if( num < 10 )
      ret = "0" + num;
    else
      ret = num;
    return ret;
  }

  function showClock() {
    let nowTime       = new Date();
    let current_Hour  = twoDigit( nowTime.getHours());
    let current_Min   = twoDigit( nowTime.getMinutes());

    let current_time  = current_Hour + ":" + current_Min
    document.getElementsByClassName('current_time')[0].innerHTML = current_time
  } //end function

  setInterval(() => {
    showClock()
  }, 1000);


  if(document.getElementsByTagName('body')[0].classList.contains('auto')) {
    let nowTime       = new Date();
    let current_Hour  = twoDigit( nowTime.getHours());
    console.log(current_Hour);
    if(current_Hour >= 16 || current_Hour <= 8){
      document.getElementsByTagName('body')[0].classList.add('dark_mode')
    }
  }

})
// END SMART CONTENT MENU.
